module.exports = __webpack_public_path__ + "static/media/caret-down.ca82bc74.svg";